import common from "./common";
import apps from "./apps";
import errors from "./errors";
import organizations from "./organizations";
import resellers from "./resellers";
import users from "./users";
import roles from "./roles";
import permissions from "./permissions";
import products from "./products";
import resellerInvoices from "./resellerInvoices";
import resellerPayments from "./resellerPayments";
import resellerProduct from "./resellerProduct";
import resellerServices from "./resellerServices";
import invoices from "./invoices";
import customers from "./customers";
import packages from "./packages";
import subscriptions from "./subscriptions";
import payments from "./payments";
import profile from "./profile";
import contacts from "./contacts";
import suppliers from "./suppliers";
import locations from "./locations";
import files from "./files";
import notifications from "./notifications";
import purchasesOrders from "./purchasesOrders";
import purchasesInvoices from "./purchasesInvoices";
import purchasesDeliveries from "./purchasesDeliveries";
import purchasesPayments from "./purchasesPayments";
import salesOrders from "./salesOrders";
import salesInvoices from "./salesInvoices";
import salesDeliveries from "./salesDeliveries";
import salesPayments from "./salesPayments";
import warehouses from "./warehouses";
import stockMovements from "./stockMovements";
import imports from "./imports";
import properties from "./properties";
import propertyTransactions from "./propertyTransactions";
import auctions from "./auctions";
import bids from "./bids";
import communications from "./communications";
import propertiesPayments from "./propertiesPayments";
import templatesMails from "./templatesMails";
import labels from "./labels";
import paymentMethods from "./paymentMethods";
import transactionsDPA from "./transactionsDPA";
import contracts from "./contracts";
import signatures from "./signatures";
import blackListUsers from "./blackListUsers";
import propertiesCollections from "./propertiesCollections";
import elixioConnect from "@/components/ElixioConnect/lang/fr";
import shipments from "./shipments";

export default {
  COMMON: common,
  APPS: apps,
  ERRORS: errors,
  USERS: users,
  ORGANIZATIONS: organizations,
  RESELLERS: resellers,
  ROLES: roles,
  PERMISSIONS: permissions,
  PRODUCTS: products,
  INVOICES: invoices,
  CUSTOMERS: customers,
  SUBSCRIPTIONS: subscriptions,
  PACKAGES: packages,
  PAYMENTS: payments,
  PROFILE: profile,
  CONTACTS: contacts,
  SUPPLIERS: suppliers,
  LOCATIONS: locations,
  FILES: files,
  NOTIFICATIONS: notifications,
  PURCHASES_ORDERS: purchasesOrders,
  PURCHASES_INVOICES: purchasesInvoices,
  PURCHASES_DELIVERIES: purchasesDeliveries,
  PURCHASES_PAYMENTS: purchasesPayments,
  SALES_ORDERS: salesOrders,
  SALES_INVOICES: salesInvoices,
  SALES_DELIVERIES: salesDeliveries,
  SALES_PAYMENTS: salesPayments,
  RESELLER_PRODUCTS: resellerProduct,
  RESELLER_SERVICES: resellerServices,
  RESELLER_INVOICES: resellerInvoices,
  RESELLER_PAYMENTS: resellerPayments,
  WAREHOUSES: warehouses,
  STOCK_MOVEMENTS: stockMovements,
  IMPORTS: imports,
  PROPERTIES: properties,
  AUCTIONS: auctions,
  BIDS: bids,
  PROPERTY_TRANSACTIONS: propertyTransactions,
  COMMUNICATIONS: communications,
  PROPERTIES_PAYMENTS: propertiesPayments,
  TEMPLATES_MAILS: templatesMails,
  LABELS: labels,
  PAYMENT_METHODS: paymentMethods,
  TRANSACTIONS_DPA: transactionsDPA,
  CONTRACTS: contracts,
  SIGNATURES: signatures,
  BLACK_LIST_USERS: blackListUsers,
  PROPERTIES_COLLECTIONS: propertiesCollections,
  ELIXIO_CONNECT: elixioConnect,
  SHIPMENTS: shipments,
};
